import {
  InventoryIndex,
  InventoryHistoryIndex,
  InventoryWasteCauseIndex,
  InventoryViewer,
  InventoryTemplateIndex,
  InventoryTemplateEditor
} from "../views";

export const inventoryRouter = {
  main: [
    {
      path: "inventory",
      name: "InventoryIndex",
      component: InventoryIndex
    },
    {
      path: "inventory-history",
      name: "InventoryHistoryIndex",
      component: InventoryHistoryIndex
    },
    {
      path: "wastecause",
      name: "InventoryWasteCauseIndex",
      component: InventoryWasteCauseIndex
    },
    {
      path: "inventory/template",
      name: "InventoryTemplateIndex",
      component: InventoryTemplateIndex
    },
    {
      path: "inventory/template/editor",
      name: "InventoryTemplateEditor",
      component: InventoryTemplateEditor
    }
  ],
  viewer: [
    {
      path: "inventory/:date?",
      name: "InventoryViewer",
      component: InventoryViewer,
      props: true
    }
  ]
};
